module.exports = __webpack_public_path__ + "img/error_background.3dd83e2f.svg";